import { CurrencyUtil } from "./CurrencyUtil";

export interface CurrencyType {
    amount: number;
    base_amount?: number;
    currency_code?: string;
    conversion_rate?: number;
    conversion_date?: Date;
}

export class Currency {
    #currencySettings = CurrencyUtil.getCurrencySettings();
    #amount: number
    #base_amount: number
    #currency_code: string
    #conversion_rate: number
    #conversion_date: Date


    constructor(currency: CurrencyType) {
        this.#amount = currency.amount;
        this.#base_amount = currency.base_amount;
        this.#currency_code = currency.currency_code 
            ? currency.currency_code 
            : this.#currencySettings.effective_currency_code;
        this.#conversion_rate = currency.conversion_rate;
        this.#conversion_date = currency.conversion_date
            ? currency.conversion_date
            : this.#currencySettings.override_conversion_date;
    }

    update(amount: number): void {
        this.#amount = Number.parseFloat(amount.toFixed(2));
        this.#base_amount = undefined;
        this.#conversion_rate = undefined;
    }

    toString(formatted: boolean = true): string {
        if (!formatted)
            return this.#amount.toString();

        const formatter = new Intl.NumberFormat(undefined, {
            style: 'currency',
            currency: this.#currency_code,
        })
        return formatter.format(this.#amount);
    }

    static createCurrency(amount: number | string): Currency {
        return new Currency({amount: (typeof amount === "string") 
            ? parseFloat(amount)
            : amount})
    }

    // Getters & Setters
    set amount(amount: number) {
        this.#amount = amount;
    }
    get amount(): number {
        return this.#amount;
    }

    set baseAmount(baseAmount: number) {
        this.#base_amount = baseAmount;
    }
    get baseAmount(): number {
        return this.#base_amount;
    }

    set currencyCode(currencyCode: string) {
        this.#currency_code = currencyCode;
    }
    get currencyCode(): string {
        return this.#currency_code;
    }

    set conversionRate(conversionRate: number) {
        this.#conversion_rate = conversionRate;
    }
    get conversionRate(): number {
        return this.#conversion_rate;
    }

    set conversionDate(conversionDate: Date) {
        this.#conversion_date = conversionDate;
    }
    get conversionDate(): Date {
        return this.#conversion_date;
    }
}